/**
 * The api's honest answer to "can I get this transfer back?" (kitecorp/transferify-api-service#96),
 * served on every `TransferDto` and mirrored here as a string union — the wire values ARE the Java enum
 * names, so no boundary mapping is needed (unlike {@link ./ExpiresAfter}, whose app-facing form is
 * numeric).
 *
 * The api derives this from the clock on every read, so the ui must never re-derive it from dates: a
 * client that computed "recoverable" itself would drift from the server the moment the two clocks
 * disagree, and would offer a button the api rejects.
 */
export const TransferRecoveryState = {
	/** Not expired: the download link still works, so there is nothing to recover. */
	LIVE: "LIVE",
	/** Expired, bytes still retained, recovery unspent — `recoverableUntil` is the deadline. */
	RECOVERABLE: "RECOVERABLE",
	/** The single recovery was spent; the link is live again until `expiresAt`. There is no second one. */
	RECOVERED: "RECOVERED",
	/** The retained window elapsed: the files are deleted and nothing can bring them back. */
	PURGED: "PURGED",
	/** Never retained for recovery — a tier without the entitlement, or a shape that stores no objects. */
	INELIGIBLE: "INELIGIBLE",
} as const;

export type TransferRecoveryState = typeof TransferRecoveryState[keyof typeof TransferRecoveryState];
